<template>
  <div v-if="currentSupplier !== undefined" id="content-page-table" class="table-fix-head" :style="fixHeadCalculatedStyle">
    <table class="table table-hover table-sm table-fit align-middle">
      <thead>
        <tr>
          <th>
            {{ $t('field.generic.item') }}
            <font-awesome-icon :icon="['fas', 'sort-up']" />
          </th>
          <th>{{ $t('field.order.orderedQuantity') }}</th>
          <th>{{ $t('field.masterdata.orderUnitCode') }}</th>
          <th>{{ $t('field.supplier.itemCode') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(supplierItem, index) in sortedList" :key="index">
          <td><ItemField :item="supplierItem.item" /></td>
          <td><span class="text-melodi">{{supplierItem.proposedOrderQuantity}}</span></td>
          <td>
            <span v-if="supplierItem.orderUnitCode === supplierItem.baseUnitCode" class="text-melodi fw-bold">{{ supplierItem.orderUnitCode }}</span>
            <span v-else class="text-melodi">{{ supplierItem.orderUnitCode }}&nbsp;à&nbsp;{{ supplierItem.factor }}&nbsp;{{ supplierItem.baseUnitCode }}</span>
          </td>
          <td>{{ supplierItem.code }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div v-else>
    <slot name="empty-list" />
  </div>

</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useSupplierItemsStore, useSuppliersStore } from '@/stores';
import { ItemField } from '@/components/fields';

const suppliersStore = useSuppliersStore();
const supplierItemsStore = useSupplierItemsStore();

const props = defineProps({
  supplierId: { type: Number, required: true }
});

const offsetTop = ref(0);
const offsetTopInterval = ref<NodeJS.Timeout | null>(null);

onMounted(() => {
  // workaround for the offsetTop calculation, as the component might not be fully rendered when the offsetTop is calculated
  offsetTopInterval.value = setInterval(() => {
    offsetTop.value = document.querySelector('#content-page-table')?.getBoundingClientRect().top ?? 0;
  }, 1000);
  offsetTop.value = document.querySelector('#content-page-table')?.getBoundingClientRect().top ?? 0;
});

onUnmounted(() => {
  if (offsetTopInterval.value) {
    clearInterval(offsetTopInterval.value);
    offsetTopInterval.value = null;
  }
});

const fixHeadCalculatedStyle = computed(() => {
  return {
    height: `calc(100vh - ${offsetTop.value}px)`,
  };
});

const mappedSupplierItems = computed(() => {
  if (currentSupplier.value === undefined) {
    return [];
  }
  return supplierItemsStore.getSupplierItems(currentSupplier.value.id);
});

const sortedList = computed(() => {
  if (currentSupplier.value === undefined) {
    return [];
  }
  return [...mappedSupplierItems.value].sort((a, b) =>
    a.item.name.localeCompare(b.item.name)
  );
});

const currentSupplier = computed(() => {
  return suppliersStore.getById(props.supplierId)
});
</script>
